import React from 'react'
import Timeline from './Timeline'
import { useInViewOnce } from '../../Utilities/Observer';

const Schedule = () => {
    const [ref, visible] = useInViewOnce();

  return (
    <section 
        id='programma'
        className='w-screen bg-brand-black px-6 md:px-8 xl:px-[8vw] pt-12 sm:pt-16 lg:pt-24 sm:pb-12'
    >
        <article  ref={ref} className={`transition-all duration-500 ease-out 
          ${visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
        > 
            <p className='font-mono text-brand-blue uppercase'>// Schedule</p>
            <h2 className='uppercase text-brand-white font-display font-black text-5xl sm:text-[clamp(2.4rem,6vw,6.5rem)] leading-none'>Schedule</h2>
        </article>

        <Timeline/>
    </section>
  )
}

export default Schedule